export default __webpack_public_path__ + "static/media/xMassRectangle.00231c95.png";